export default __webpack_public_path__ + "static/dogecoin-a9424efadeaad7cd97e77fd96f8e9354.png";